import PropTypes from 'prop-types'
import React from 'react'

import Button from 'components/common/Button'
import OverlayLoadingIndicator from 'components/common/OverlayLoadingIndicator'

import { EMAIL_CONTACT_METHOD, PHONE_NUMBER_CONTACT_METHOD, VALID_COUNTRY_CODES } from 'src/services/contact_methods'
import ContactMethodFields from 'components/login_form/ContactMethodFields'

import styles from './contact-method-fields-form.scss'
import inputStyles from 'src/styles/inputs.css'
import SvgIcon from 'components/common/SvgIcon'
import LeftChevronIcon from 'src/assets/icons/left_chevron.svg'

export default class ContactMethodFieldsForm extends React.Component {
  state = {
    showErrors: false
  }

  _contactMethodType = () => {
    const { contactMethod } = this.props
    return contactMethod ? contactMethod.type : PHONE_NUMBER_CONTACT_METHOD
  }

  _phoneNumberValid () {
    return this.props.fields.phoneNumber.length === 11
  }

  _countryCodeValid () {
    const { countryCode } = this.props.fields
    const validCodes = VALID_COUNTRY_CODES.map(c => c.code)
    return validCodes.indexOf(countryCode) >= 0
  }

  _contactMethodIsValid () {
    switch (this._contactMethodType()) {
      case EMAIL_CONTACT_METHOD:
        // FIXME: we should do at least some validation
        return true
      case PHONE_NUMBER_CONTACT_METHOD:
        return this._phoneNumberValid() && this._countryCodeValid()
      default:
        return this._phoneNumberValid() && this._countryCodeValid()
    }
  }

  _inputClassName () {
    const { transparent } = this.props
    return transparent ? 'transparent-text-input' : 'text-input'
  }

  _loginFormClassName () {
    const { fields, transparent } = this.props
    const loading = fields.confirmationCodeLoading
    if (loading) {
      return transparent ? 'login-form-loading-transparent' : 'login-form-loading'
    } else {
      return 'login-form'
    }
  }

  _renderForm () {
    const { updateForm, fields, setUseMaskedEmailFalse } = this.props
    const { showErrors } = this.state
    const inputClassName = this._inputClassName()
    const loginFormStyleName = this._loginFormClassName()

    return (
      <form
        className={styles[loginFormStyleName]}
        onSubmit={this._onSubmit}
      >
        <div className={styles['name-fields']}>
          <ContactMethodFields
            className={inputStyles[inputClassName]}
            contactMethodType={this._contactMethodType()}
            fields={fields}
            setUseMaskedEmailFalse={setUseMaskedEmailFalse}
            updateForm={updateForm}
            valid={!showErrors || this._contactMethodIsValid()}
          />
          <span className={styles['form-tip']}>Don't worry, we'll never spam or share your number.</span>
        </div>
        <div className={styles['button-wrapper']}>
          <Button disabled={!this._formIsValid()} className={styles['button']} onClick={this._onSubmit}>Next</Button>
        </div>
        <input style={{ display: 'none' }} type='submit' />
      </form>
    )
  }

  _formIsValid () {
    return this._contactMethodIsValid()
  }

  _onSubmit = (e) => {
    const { submitForm } = this.props
    e.preventDefault()
    if (this._formIsValid()) {
      submitForm()
    } else {
      this.setState({ showErrors: true })
    }
  }

  render () {
    const { fields, transparent, backToLoginFormPage, isMenu } = this.props
    const loading = fields.confirmationCodeLoading

    return (
      <div className={styles[`container${isMenu && '--is-menu'}`]}>
        <div>
          <div className={styles['icon-wrapper']}>
            <SvgIcon className={styles['left-chevron-icon']} icon={LeftChevronIcon} padding='5px' onClick={backToLoginFormPage} />
          </div>
          {this._renderForm()}
          <OverlayLoadingIndicator loading={loading} light={!transparent} />
        </div>
        <span className={styles['confirmation-text']}>By using Hobnob, you agree to our <a target='_blank' rel='noopener noreferrer' href='https://hobnob.app/privacy/'>Privacy
          Policy</a> and <a href='https://hobnob.app/terms/' target='_blank' rel='noopener noreferrer'>Terms</a></span>
      </div>
    )
  }
}

ContactMethodFieldsForm.propTypes = {
  contactMethod: PropTypes.object,
  setUseMaskedEmailFalse: PropTypes.func.isRequired,
  fields: PropTypes.object,
  updateForm: PropTypes.func.isRequired,
  submitForm: PropTypes.func.isRequired,
  transparent: PropTypes.bool,
  isMenu: PropTypes.bool,
  backToLoginFormPage: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/login_form/ContactMethodFieldsForm.jsx